<template>
  <div ref="pdfContainer" class="pdfContainer">
    <p class="text-2xl mb-6">
      Performance par catégorie (new)
      <dag-info
        :dags="[
          'adn_daily_posts_sites_infos_dag',
          'ga_get_and_store_site_daily_dag',
          'partner_get_and_store_daily_dag',
          'partner_get_and_store_daily_ifempty_dag',
          'adn_get_and_store_posts_ga_daily_dag',
          'adn_compute_data_by_period_daily_dag',
        ]"
      />
    </p>
    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-3">
        <v-col cols="12">
          <filters></filters>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <v-col cols="12">
        <top-stats-card />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <category-ca-and-session-distribution-chart />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <category-rpm-chart />
      </v-col>
      <v-col cols="6">
        <category-avg-session-by-day-chart />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <most-performing-channels-chart />
      </v-col>
      <v-col cols="6">
        <channel-rpm-chart />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <perf-per-category-table />
      </v-col>
    </v-row>

    <dot-menu
      position="page-top-right"
      :isLoading="isLoading"
      :pdfButton="{
        getContainerRef: () => $refs.pdfContainer,
        filename: 'perf_par_categorie.pdf',
      }"
    />
  </div>
</template>

<script>
import { onMounted } from "@vue/composition-api";

import DagInfo from "@/components/common/menus/DagInfo";
import DotMenu from "@/components/common/menus/DotMenu";
import Filters from "@/components/audience/perf-per-category-2/filters/Filters";
import CategoryAvgSessionByDayChart from "@/components/audience/perf-per-category-2/cards/CategoryAvgSessionByDayChart";
import CategoryCaAndSessionDistributionChart from "@/components/audience/perf-per-category-2/cards/CategoryCaAndSessionDistributionChart";
import CategoryRpmChart from "@/components/audience/perf-per-category-2/cards/CategoryRpmChart";
import ChannelRpmChart from "@/components/audience/perf-per-category-2/cards/ChannelRpmChart";
import MostPerformingChannelsChart from "@/components/audience/perf-per-category-2/cards/MostPerformingChannelsChart";
import PerfPerCategoryTable from "@/components/audience/perf-per-category-2/tables/PerfPerCategory";
import TopStatsCard from "@/components/audience/perf-per-article/cards/TopStatsCard";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "PerfPerCategory",
  components: {
    DagInfo,
    DotMenu,
    Filters,
    CategoryCaAndSessionDistributionChart,
    CategoryAvgSessionByDayChart,
    CategoryRpmChart,
    ChannelRpmChart,
    MostPerformingChannelsChart,
    PerfPerCategoryTable,
    TopStatsCard,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();
    const { route } = useProxy();

    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      saveRmraView(route);
    });

    // =>  DATA
    return {
      isLoading,
    };
  },
};
</script>

<style scoped>
.pdfContainer {
  position: relative;
}
</style>
